import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import EditQuestionDetails from "QuestionBank/routes/EditQuestionDetails";
export default store => ({
  path: "question-library",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "worksheet-question-library" */ "./components"
        ),
        import(
          /* webpackChunkName: "worksheet-question-library" */ "./modules/QuestionBankModule"
        ),
        import(
          /* webpackChunkName: "worksheet-question-library" */ "AppComponents/MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const questionBankReducer = importedModule1;
        const multiLevelNodeEditorReducer = importedModule2;
        injectReducer(store, {
          key: questionBankReducer.NAME,
          reducer: questionBankReducer.default,
        });
        injectReducer(store, {
          key: multiLevelNodeEditorReducer.NAME,
          reducer: multiLevelNodeEditorReducer.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [EditQuestionDetails(store)],
});
